import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './../store';
import Constants from './../constants';
import Permissions from '../mixins/PermissionsHelpers.vue';

Vue.use(VueRouter);

const routes = [{
  path: '/login/:session?',
  name: 'Login',
  component: require('../views/auth/Login').default,
  meta: {
    hideForAuth: true
  }
},
{
  path: '/register/:type?',
  name: 'Register',
  component: require('../views/auth/Register').default,
  meta: {
    hideForAuth: true
  }
},
{
  path: '/password/reset',
  name: 'ForgotPassword',
  component: require('../views/auth/ForgotPassword').default,
  meta: {
    hideForAuth: true
  }
},
{
  path: '/password/reset/:token',
  name: 'ResetPasswordForm',
  component: require('../views/auth/ResetPasswordForm').default,
  meta: {
    hideForAuth: true
  }
},
{
  path: '/createReferentPassword/:token',
  name: 'CreateReferentPassword',
  component: require('../views/auth/CreateReferentPassword').default,
  meta: {
    hideForAuth: true
  },
},
{
  path: '/loginGuest/:token',
  name: 'LoginGuest',
  component: require('../views/auth/LoginGuest').default,
},
{
  path: '/invite-expired',
  name: 'InviteExpired',
  component: require('../views/auth/InviteExpired').default,
  hideForAuth: true,
  props: true,
},
{
  path: '',
  component: require('../views/layouts/MainLayout').default,
  meta: {
    requireAuth: true
  },
  children: [
    {
      path: '/',
      name: 'Dashboard',
      component: require('../views/dashboard/Dashboard').default,
      async beforeEnter(to, from, next) {
        await store.dispatch('template/loadModulesPages').then(async () => {
          if(Permissions.methods.$can(Constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_DISPLAY)){ // verify permissions
          //load datas for collectives carto to update after neopass data changes
            await store.dispatch('cartographiesCollectives/load_datas', Constants.PAGE_CARTOGRAPHIE_COLLECTIVE_INFORMATIONS);
          }
          next();
        });
      }
    },
    { // Super Admin screen
      path:'/abonnements',
      name:'Abonnements',
      component: require('./../views/admin/AbonnementsList').default,
      beforeEnter(to, from, next) {
        if(store.getters['auth/role'] != Constants.ROLE_SUPER_ADMIN){
          next({name: 'Notfound'});
          return;
        }
        next();
      }
    },
    { // Super Admin screen
      path: '/historiques',
      name: 'Historique',
      component: require('../views/admin/History').default,
      meta: {
        requireAuth: true
      },
      beforeEnter(to, from, next){
        if(store.getters['auth/role'] != Constants.ROLE_SUPER_ADMIN){
          next({name: 'Notfound'});
          return;
        }
        next();
      }
    },
    { // Super Admin screen
      path:'/affiliations',
      name:'Affiliations',
      component: require('./../views/admin/AffiliationsList').default,
      beforeEnter(to, from, next) {
        if(store.getters['auth/role'] != Constants.ROLE_SUPER_ADMIN){
          next({name: 'Notfound'});
          return;
        }
        next();
      }
    },
    {
      path: '/aide',
      name: 'Help',
      component: require('./../views/layouts/HelpLayout').default,
      children: [{
        path: 'contact',
        name: 'HelpContact',
        component: require('../views/help/Contact').default,
        beforeEnter(to, from, next) {
          store.commit('account/SET_TABDISPLAY', 'informations');
          next();
        },
      }, ]
    },
    {
      path: '/parametres-de-compte',
      name: 'Account',
      component: require('./../views/layouts/AccountLayout').default,
      beforeEnter(to, from, next) {
        store.dispatch('account/isPayer').then(() => {
          next();
        });
      },
      children: [
        {
          path: 'informations',
          name: 'Accountinformations',
          component: require('../views/account/Informations').default,
          beforeEnter(to, from, next) {
            if (store.getters['auth/permissions'].includes(Constants.PERMISSION_PARAMETRE_COMPTE_INFORMATIONS_COMPTE)) {
              store.dispatch('account/loadInformations');
              store.commit('app/SET_ALLOWED', true);
              store.commit('account/SET_TABDISPLAY', 'informations');
              store.commit('account/SET_ERRORS', null);
            } else {
              store.commit('app/SET_ALLOWED', false);
            }
            next();
          },
        },
        {
          path: 'mon-abonnement',
          name: 'Accountsubscription',
          component: require('../views/account/Subscription').default,
          beforeEnter(to, from, next) {
            if(store.getters['auth/permissions'].includes(Constants.PERMISSION_PARAMETRE_COMPTE_ABONNEMENT)){
              store.commit('app/SET_ALLOWED', true);
              store.dispatch('account/isPayer').then(() => {
                store.commit('account/SET_TABDISPLAY', 'abonnements');

              });
            }else{
              store.commit('app/SET_ALLOWED', false);
            }
            next();
          },
        },
        {
          path: 'historiques-de-paiement',
          name: 'Accountbillinghistory',
          component: require('../views/account/BillingHistory').default,
          beforeEnter(to, from, next) {
            store.commit('account/SET_TABDISPLAY', 'paiements');

            if(store.getters['auth/permissions'].includes(Constants.PERMISSION_PARAMETRE_COMPTE_HISTORIQUE_FACTURE)){
              store.commit('app/SET_ALLOWED', true);
              store.dispatch('account/getBillingHistory').then((response) => {
                store.commit('account/SET_BILLINGHISTORY', response);
              });
            }else{
              store.commit('app/SET_ALLOWED', false);
            }
            next();
          },
        }
      ],
    },
    {
      path: '/abonnement',
      name: 'Subscription',
      component: require('./../views/layouts/SubscriptionLayout').default,
      beforeEnter(to, from, next) {
        store.dispatch('account/isPayer').then(() => {
          next();
        });
      },
      children: [{
        path: 'choix-abonnement',
        name: 'Subscriptionchoice',
        component: require('../views/account/SubscriptionChoice').default,
      },
      {
        path: 'choix-abonnement/verified',
        name: 'Subscriptionchoice',
        component: require('../views/account/SubscriptionChoice').default,
      },
      {
        path: 'standard',
        name: 'Subscriptionstandard',
        component: require('../views/account/SubscriptionStandard').default,
        beforeEnter(to, from, next){
          if(!Permissions.methods.$subscription()){
            next();
          }
          if(Permissions.methods.$subscription()){
            next({name:'Accountsubscription'});
          }

        }
      },
      ]
    },
    {
      path: '/user-history/:user',
      name: 'UserHistory',
      component: require('../views/neopass/UserHistory').default,
    },
    {
      path: '/neopass',
      name: 'Neopass',
      component: require('../views/neopass/NeopassIndex').default,
      async beforeEnter(to, from, next) {
        if (store.getters['auth/role'] == Constants.ROLE_BENEFICIAIRE) { // Benéficiary hasn't access to neopass list
          if (from.path.includes('form/neopass')) {
            router.go('/');
          }
          if (!from.path.includes('form/neopass')) {
            let user = store.getters['auth/user'];
            next('/form/neopass/' + user.id);
          }
        }

        if (store.getters['auth/role'] != Constants.ROLE_BENEFICIAIRE) {
          if (store.getters['auth/permissions'].includes(Constants.PERMISSION_NEOPASS_PAGE)) { // If user allowed
            store.commit('app/SET_ALLOWED', true);
          } else {
            store.commit('app/SET_ALLOWED', false);
          }

          await store.dispatch('permissions/loadModulesPages'); //load information for rights modal
          await store.dispatch('beneficiaries/loadBeneficiaries',
            {
              hasLoading: true,
              hasPagination: 1,
            }
          ).then(() => {
            next();
          });
        }
      }
    },
    {
      path: '/curriculumvitae',
      name: 'CurriculumVitae',
      component: require('../views/layouts/CvLayout.vue').default,
      redirect: {name: 'listCvs'},
      async beforeEnter(to, from, next) {
        if (!(store.getters['auth/role'] === Constants.ROLE_BENEFICIAIRE || Permissions.methods.$freeParticulier())) { // Only bénéficiaire and particuliers
          router.go('/');
        }
        next();
      },
      children:[
        {
          path: '',
          name: 'listCvs',
          component: require('../views/curriculumVitae/Index.vue').default,
          beforeEnter: (to, from, next) => {
            store.dispatch('curriculumVitae/loadCvs').then(() => {
              next();
            }).catch(err => {
              console.log(err);
              next('/');
            });
          },
        },
        {
          path: 'form/:user/:id',
          name: 'CvForm',
          component: require('../views/curriculumVitae/Formulaire.vue').default,
          beforeEnter: (to, from, next) => {
            store.dispatch('curriculumVitae/loadCvs').then(() => {
              let idCv = to.params.id;

              let cv = store.getters['curriculumVitae/listCvs'].filter(c => c.id == idCv)[0];

              store.commit('curriculumVitae/SET_FORM', cv);

              store.commit('curriculumVitae/SET_CURRENTSTEP', (cv.last_step != '' && cv.last_step != null) ? cv.last_step : 'shaping');

              next();

            }).catch(err => {
              console.log(err);
              next('/');
            });
          },
        },
      ],
    },
    {
      path: '/recherchecompetences',
      name: 'RechercheCompetences',
      component: require('../views/layouts/RechercheLayout.vue').default,
      redirect: {name: 'MoteurRecherche'},
      beforeEnter:(to, from, next) => {
        if (store.getters['auth/permissions'].includes(Constants.PERMISSION_RECHERCHE_COMPETENCES_PAGE)) { // If user allowed
          store.commit('app/SET_ALLOWED', true);
        } else {
          store.commit('app/SET_ALLOWED', false);
        }
        store.dispatch('rechercheCompetences/loadReferentiels').then(() => {
          next();
        });
      },
      children:[
        {
          path: 'recherche',
          name: 'MoteurRecherche',
          component: require('../views/rechercheCompetences/Recherche.vue').default,
        },
      ]
    },
    {
      path: '/fiches-de-poste',
      name: 'JobDescription',
      component: require('../views/JobDescription').default,
      beforeEnter(to, from, next) {
        if (store.getters['auth/permissions'].includes(Constants.PERMISSION_FICHE_DE_POSTE_PAGE)) { // If user allowed
          store.commit('app/SET_ALLOWED', true);
        } else {
          store.commit('app/SET_ALLOWED', false);
        }
        next();
      }
    },
    {
      path: '/ref-formation',
      name: 'ReferentielFormation',
      component: require('../views/JobDescription').default,
      beforeEnter(to, from, next) {
        if (store.getters['auth/permissions'].includes(Constants.PERMISSION_REFERENTIEL_FORMATION_PAGE)) { // If user allowed
          store.commit('app/SET_ALLOWED', true);
        } else {
          store.commit('app/SET_ALLOWED', false);
        }
        next();
      }
    },
    {
      path: '/tracking-routes',
      name: 'TrackingRoutes',
      component: require('../views/TrackingRoutes').default
    },
    {
      path: '/preconisations',
      name: 'PrecoEmploiStage',
      component: require('../views/PrecoEmploiStage').default,
      beforeEnter: (to, from, next) => {
        if (store.getters['auth/permissions'].includes('preconisations')) {
          next();
        } else {
          next('/not-allowed');
        }
      }
    },
    {
      path: '/not-allowed',
      name: 'notAllowed',
      component: require('../views/NotAllowed').default
    },
    {
      path: '/notFound',
      name: 'Notfound',
      component: require('../views/Error404').default
    },
    /**************************************************** *
  ******************* MODELES DE PAGE *******************
  ******************************************************/
    { //Template pages
      path: '/modeles-de-page/:id_template',
      component: require('../views/layouts/TemplateLayout').default,
      children: [ // by template type
        {
          path: 'multi1/:module/:page',
          name: 'multi1',
          component: require('../views/templates/ReferentielMulti1').default,
          meta: {
            canSave: true
          },
        },
        {
          path: 'multi2/:module/:page',
          name: 'multi2',
          component: require('../views/templates/ReferentielMulti2').default,
          meta: {
            canSave: true
          },
        },
        {
          path: 'multi3/:module/:page',
          name: 'multi3',
          component: require('../views/templates/ReferentielMulti3').default,
          meta: {
            canSave: true
          },
        },
        {
          path: 'euro/:module/:page',
          name: 'euro',
          component: require('../views/templates/ReferentielEuropeen').default,
          meta: {
            canSave: false
          },
        },
        {
          path: 'clea/:module/:page',
          name: 'clea',
          component: require('../views/templates/ReferentielClea').default,
          meta: {
            canSave: false
          },
        },
        {
          path: 'pro/:module/:page',
          name: 'pro',
          component: require('../views/templates/ReferentielPro').default,
          meta: {
            canSave: true
          },
        },
        {
          path: 'sco/:module/:page',
          name: 'sco',
          component: require('../views/templates/ReferentielSco').default,
          meta: {
            canSave: true
          },
        },
        {
          path: 'clea_num/:module/:page',
          name: 'clea_num',
          component: require('../views/templates/ReferentielCleaInformatique').default,
          meta: {
            canSave: false
          },
        },
      ]
    },
    /**************************************************** *
             ***************** FORMULAIRES NEOPASS *****************
             ******************************************************/
    { //Passeport form pages
      path: '/form/neopass/:id',
      component: require('../views/layouts/PassLayout').default,
      name: 'neopass_form',
      beforeEnter: (to, from, next) => {
        next();
      },
      children: [
        {
          path: 'cv',
          name: 'cv',
        },
        {
          path: 'cv/informationsgenerales',
          name: 'cvinformationsgenerales',
          component: require('../views/neopass/formulaires/InformationsGenerales').default,
        },
        {
          path: 'cv/situationpersonnelle',
          name: 'cvsituationpersonnelle',
          component: require('../views/neopass/formulaires/SituationPersonnelle').default,
        },
        {
          path: 'cv/situationprofessionnelle',
          name: 'cvsituationprofessionnelle',
          component: require('../views/neopass/formulaires/SituationProfessionnelle').default,
        },
        {
          path: 'cv/parcours',
          name: 'cvparcours',
          component: require('../views/neopass/formulaires/Parcours').default,
        },
        {
          path: 'cv/portfolio',
          name: 'cvportfolio',
          component: require('../views/neopass/formulaires/Portfolio').default,
        },
        {
          path: 'compperso',
          name: 'compperso',
        },
        {
          path: 'compperso/extrapro',
          name: 'comppersoextrapro',
          component: require('../views/neopass/formulaires/ActivitesExtraProfessionnelles').default,
        },
        {
          path: 'compperso/compcle',
          name: 'comppersocompcle',
          component: require('../views/neopass/formulaires/CompetencesCles').default,
        },
        {
          path: 'compperso/informatique',
          name: 'comppersoinformatique',
          component: require('../views/neopass/formulaires/NiveauInformatique').default,
        },
        {
          path: 'compperso/langue',
          name: 'comppersolangue',
          component: require('../views/neopass/formulaires/MaitriseDesLangues').default,
        },
        {
          path: 'compsocio',
          name: 'compsocio',
        },
        {
          path: 'compsocio/aptitudes_perso',
          name: 'compsocioaptitudes_perso',
          component: require('../views/neopass/formulaires/ReferentielMulti2').default,
        },
        {
          path: 'compsocio/comportement_social',
          name: 'compsociocomportement_social',
          component: require('../views/neopass/formulaires/ReferentielMulti2').default,
        },
        {
          path: 'compsocio/aptitudes_pro',
          name: 'compsocioaptitudes_pro',
          component: require('../views/neopass/formulaires/ReferentielMulti2').default,
        },
        {
          path: 'compsocio/productivite',
          name: 'compsocioproductivite',
          component: require('../views/neopass/formulaires/ReferentielMulti2').default,
        },
        {
          path: 'compsocio/attitudes_pro',
          name: 'compsocioattitudes_pro',
          component: require('../views/neopass/formulaires/ReferentielMulti2').default,
        },
        {
          path: 'compsocio/regles',
          name: 'compsocioregles',
          component: require('../views/neopass/formulaires/ReferentielMulti2').default,
        },
        {
          path: 'comppro',
          name: 'comppro',
        },
        {
          path: 'comppro/p1',
          name: 'compprop1',
          component: require('../views/neopass/formulaires/CompetencesPro').default,
        },
        {
          path: 'comppro/p2',
          name: 'compprop2',
          component: require('../views/neopass/formulaires/CompetencesPro').default,
        },
        {
          path: 'comppro/p3',
          name: 'compprop3',
          component: require('../views/neopass/formulaires/CompetencesPro').default,
        },
        {
          path: 'comppro/p4',
          name: 'compprop4',
          component: require('../views/neopass/formulaires/CompetencesPro').default,
        },
        {
          path: 'comppro/p5',
          name: 'compprop5',
          component: require('../views/neopass/formulaires/CompetencesPro').default,
        },
        {
          path: 'compsco',
          name: 'compsco',
        },
        {
          path: 'compsco/f1',
          name: 'compscof1',
          component: require('../views/neopass/formulaires/CompetencesSco').default,
        },
        {
          path: 'compsco/f2',
          name: 'compscof2',
          component: require('../views/neopass/formulaires/CompetencesSco').default,
        },
        {
          path: 'compsco/f3',
          name: 'compscof3',
          component: require('../views/neopass/formulaires/CompetencesSco').default,
        },
        {
          path: 'compsco/f4',
          name: 'compscof4',
          component: require('../views/neopass/formulaires/CompetencesSco').default,
        },
        {
          path: 'compsco/f5',
          name: 'compscof5',
          component: require('../views/neopass/formulaires/CompetencesSco').default,
        },
        {
          path: 'preconisation',
          name: 'preconisation',
        },
        {
          path: 'preconisation/autonomie',
          name: 'preconisationautonomie',
          component: require('../views/neopass/formulaires/Autonomie').default,
        },
        {
          path: 'preconisation/accessibilite',
          name: 'preconisationaccessibilite',
          component: require('../views/neopass/formulaires/Accessibilite').default,
        },
        {
          path: 'preconisation/poste',
          name: 'preconisationposte',
          component: require('../views/neopass/formulaires/Postedetravail').default,
        },

        {
          path: 'preconisation/checklist',
          name: 'preconisationchecklist',
          component: require('../views/neopass/formulaires/ChecklistDesMoyensMisEnPlace').default,
        },
        {
          path: 'plan',
          name: 'plan',
        },
        {
          path: 'plan/bilans',
          name: 'planbilans',
          component: require('../views/neopass/formulaires/Bilans').default,
        },
        {
          path: 'plan/projets',
          name: 'planprojets',
          component: require('../views/neopass/formulaires/Projets').default,
        },
        {
          path: 'plan/compterendu',
          name: 'plancompterendu',
          component: require('../views/neopass/formulaires/CompteRendu').default,
        },
        {
          path: 'depotdocuments',
          name: 'depotdocuments',
        },
        {
          path: 'depotdocuments/documents',
          name: 'depotdocumentsdocuments',
          component: require('../views/neopass/formulaires/Documents').default,
          beforeEnter: (to, from, next) => {
            if(store.getters['auth/role'] === Constants.ROLE_BENEFICIAIRE){
              next( {name: 'Dashboard'} );
            }

            let url = to.path.split('/form/neopass/')[1].split('/');
            store.commit('depotDocuments/SET_TARGETID', url[0]);
            store.dispatch('depotDocuments/loadFiles').then(() => {
              next();
            });
          },
          //TODO: beforeRouteLeave n'est pas applicable en dehors d'un composant, à revérifer
        /*beforeRouteLeave(to, from){
          store.commit('depotDocuments/SET_TARGETID', store.getters['auth/user'].id);
        }*/
        },
      ]
    },
    /**************************************************** *
             ************** CARTOGRAPHIES COLLECTIVES **************
             ******************************************************/
    {
      path: '/cartographies/collectives',
      name: 'Cartographiescollectives',
      component: require('../views/layouts/CartoCollectiveLayout').default,
      beforeEnter(to, from, next) {
        if (store.getters['auth/role'] == Constants.ROLE_BENEFICIAIRE) { // Benéficiary hasn't access to collectives cartographies
          next({
            name: 'Cartoindcompperso'
          });
        }
        if (store.getters['auth/permissions'].includes(Constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_PAGE)) {
          store.commit('app/SET_ALLOWED', true);
        } else {
          store.commit('app/SET_ALLOWED', false);
        }
        store.dispatch('cartographiesCollectives/first_load_page').then(() => {
          next();
        }, () => {
          next({
            name: 'Dashboard'
          });
        });
      },
      children: [
        {
          path: 'informations',
          name: 'Informationsgénérales',
          component: require('../views/cartographies/collectives/InformationsGenerales').default,
          beforeEnter: (to, from, next) => {
            let page = to.path.split('/cartographies/collectives/')[1].split('/')[0];
            store.dispatch('cartographiesCollectives/change_page', page).then(() => {
              next();
            }, () => {
              next({
                name: 'Dashboard'
              });
            });
          },
        },
        {
          path: 'cartographiesstagesformations',
          name: 'CartographieStagesFormations',
          component: require('../views/cartographies/collectives/StagesFormations').default,
          beforeEnter: (to, from, next) => {
            let page = to.path.split('/cartographies/collectives/')[1].split('/')[0];
            store.dispatch('cartographiesCollectives/change_page', page).then(() => {
              next();
            }, () => {
              next({
                name: 'Dashboard'
              });
            });
          },
        },
        {
          path: 'cartographiescompetencescles',
          name: 'CartographieCompetencesCles',
          component: require('../views/cartographies/collectives/CompetencesCles').default,
          beforeEnter: (to, from, next) => {
            let page = to.path.split('/cartographies/collectives/')[1].split('/')[0];
            store.dispatch('cartographiesCollectives/change_page', page).then(() => {
              next();
            }, () => {
              next({
                name: 'Dashboard'
              });
            });
          },
        },
        {
          path: 'cartographiespostes',
          name: 'CartographiePostesMetiers',
          component: require('../views/cartographies/collectives/PostesMetiers').default,
          beforeEnter: (to, from, next) => {
            let page = to.path.split('/cartographies/collectives/')[1].split('/')[0];
            store.dispatch('cartographiesCollectives/change_page', page).then(() => {
              next();
            }, () => {
              next({
                name: 'Dashboard'
              });
            });
          },
        },
        {
          path: 'cartographiesplan',
          name: 'CartographiePlanAccompagnement',
          component: require('../views/cartographies/collectives/PlanAccompagnement').default,
          beforeEnter: (to, from, next) => {
            let page = to.path.split('/cartographies/collectives/')[1].split('/')[0];
            store.dispatch('cartographiesCollectives/change_page', page).then(() => {
              next();
            }, () => {
              next({
                name: 'Dashboard'
              });
            });
          },
        },
      ]
    },
    /**************************************************** *
             ************* CARTOGRAPHIES INDIVIDUELLES *************
             ******************************************************/
    { // Cartographies individuelles
      path: '/cartographies/individuelles/:id',
      name: 'Cartographiesindividuelles',
      component: require('../views/layouts/CartoIndividuelleLayout').default,
      beforeEnter(to, from, next) {
        if (Permissions.methods.$can(Constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_PAGE)) { //TODO : create and add permission to access beneficiary cartography
          store.commit('app/SET_ALLOWED', true);
        } else {
          store.commit('app/SET_ALLOWED', false);
        }

        let id_pass = to.path.split('/cartographies/individuelles/')[1].split('/')[0];
        store.dispatch('cartographiesIndividuelles/first_load_page', id_pass).then(() => {
          next();
        }, () => {
          next({
            name: 'Dashboard'
          });
        });
      },
      children: [{
        path: 'competencesperso',
        name: 'Cartoindcompperso',
        component: require('../views/cartographies/individuelles/CompetencesPersonnelles').default,
        beforeEnter: (to, from, next) => {
          if (!store.getters['cartographiesIndividuelles/listModulesPages'].map(page => page.name).includes(Constants.PAGE_CARTOGRAPHIE_COMPETENCES_PERSO)) {
            next({
              name: 'Cartoindcompsocio',
              params: {
                id: to.params.id
              }
            });
          }

          if (!Permissions.methods.$can(Constants.PERMISSION_NEOPASS_FORM_COMPETENCES_PERSONNELLES_CONSULTER, to.params.id)
                                && !Permissions.methods.$can(Constants.PERMISSION_NEOPASS_FORM_COMPETENCES_PERSONNELLES_EDITER, to.params.id)
          ) { // User hasn't right to read module for this neopass
            store.commit('app/SET_ALLOWED', false);
          }

          let id_pass = to.path.split('/cartographies/individuelles/')[1].split('/')[0];
          let page = to.path.split('/cartographies/individuelles/')[1].split('/')[1];

          store.dispatch('cartographiesIndividuelles/change_page', [id_pass, page]).then(() => {
            next();
          }, () => {
            next({
              name: 'Dashboard'
            });
          });
        },
      },
      {
        path: 'competencessociopro',
        name: 'Cartoindcompsocio',
        component: require('../views/cartographies/individuelles/CompetencesSocioPro').default,
        beforeEnter: (to, from, next) => {
          if (!store.getters['cartographiesIndividuelles/listModulesPages'].map(page => page.name).includes(Constants.PAGE_CARTOGRAPHIE_COMPETENCES_SOCIO_PRO)) {
            next({
              name: 'Cartoindcomppro',
              params: {
                id: to.params.id
              }
            });
          }

          if (!Permissions.methods.$can(Constants.PERMISSION_NEOPASS_FORM_COMPETENCES_SOCIO_PRO_CONSULTER, to.params.id)
                                && !Permissions.methods.$can(Constants.PERMISSION_NEOPASS_FORM_COMPETENCES_SOCIO_PRO_EDITER, to.params.id)
          ) { // User hasn't right to read module for this neopass
            store.commit('app/SET_ALLOWED', false);
          }

          let id_pass = to.path.split('/cartographies/individuelles/')[1].split('/')[0];
          let page = to.path.split('/cartographies/individuelles/')[1].split('/')[1];

          store.dispatch('cartographiesIndividuelles/change_page', [id_pass, page]).then(() => {
            next();
          }, () => {
            next({
              name: 'Dashboard'
            });
          });
        },
      },
      {
        path: 'competencespro',
        name: 'Cartoindcomppro',
        component: require('../views/cartographies/individuelles/CompetencesPro').default,
        beforeEnter: (to, from, next) => {
          if (!store.getters['cartographiesIndividuelles/listModulesPages'].map(page => page.name).includes(Constants.PAGE_CARTOGRAPHIE_COMPETENCES_PRO)) {
            next({
              name: 'Dashboard'
            });
          }

          if (!Permissions.methods.$can(Constants.PERMISSION_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES_CONSULTER, to.params.id)
                                && !Permissions.methods.$can(Constants.PERMISSION_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES_EDITER, to.params.id)
          ) { // User hasn't right to read module for this neopass
            store.commit('app/SET_ALLOWED', false);
          }

          let id_pass = to.path.split('/cartographies/individuelles/')[1].split('/')[0];
          let page = to.path.split('/cartographies/individuelles/')[1].split('/')[1];

          store.dispatch('cartographiesIndividuelles/change_page', [id_pass, page]).then(() => {
            next();
          }, () => {
            next({
              name: 'Dashboard'
            });
          });
        },
      },
      {
        path: 'competencessco',
        name: 'Cartoindcompsco',
        component: require('../views/cartographies/individuelles/CompetencesScolaires').default,
        beforeEnter: (to, from, next) => {
          if (!store.getters['cartographiesIndividuelles/listModulesPages'].map(page => page.name).includes(Constants.PAGE_CARTOGRAPHIE_COMPETENCES_SCOLAIRES)) {
            next({
              name: 'Dashboard'
            });
          }

          if (!Permissions.methods.$can(Constants.PERMISSION_NEOPASS_FORM_COMPETENCES_SCOLAIRES_CONSULTER, to.params.id)
                                && !Permissions.methods.$can(Constants.PERMISSION_NEOPASS_FORM_COMPETENCES_SCOLAIRES_EDITER, to.params.id)
          ) { // User hasn't right to read module for this neopass
            store.commit('app/SET_ALLOWED', false);
          }

          let id_pass = to.path.split('/cartographies/individuelles/')[1].split('/')[0];
          let page = to.path.split('/cartographies/individuelles/')[1].split('/')[1];

          store.dispatch('cartographiesIndividuelles/change_page', [id_pass, page]).then(() => {
            next();
          }, () => {
            next({
              name: 'Dashboard'
            });
          });
        },
      }
      ]
    },
    { // Permissions
      path: '/permissions',
      name: 'Permissions',
      component: require('../views/layouts/PermissionsLayout').default,
      beforeEnter: (to, from, next) => {
        if (store.getters['auth/permissions'].includes(Constants.PERMISSION_GESTION_DROITS_ROLE_LISTE) || store.getters['auth/permissions'].includes(Constants.PERMISSION_GESTION_DROITS_REFERENT_LISTE) || store.getters['auth/permissions'].includes(Constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_LISTE)) {
          store.commit('app/SET_ALLOWED', true);
        } else {
          store.commit('app/SET_ALLOWED', false);
        }
        if (!Permissions.methods.$freeParticulier()) { // Verify premium account

          let permissions_tab = to.path.split('/permissions/')[1];

          if (permissions_tab == undefined) {
            if (store.getters['auth/permissions'].includes(Constants.PERMISSION_GESTION_DROITS_ROLE_LISTE)) {
              next({
                name: 'PermissionsRoles'
              });
            } else if (store.getters['auth/permissions'].includes(Constants.PERMISSION_GESTION_DROITS_REFERENT_LISTE)) {
              next({
                name: 'PermissionsReferents'
              });
            } else if (store.getters['auth/permissions'].includes(Constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_LISTE)) {
              next({
                name: 'PermissionsBeneficiaries'
              });
            } else if (store.getters['auth/permissions'].includes(Constants.PERMISSION_GESTION_DROITS_INVITE)) {
              next({
                name: 'PermissionsGuests'
              });
            } else {
              store.commit('app/SET_ALLOWED', false);
              next();
            }
          }
          else {
            store.dispatch('permissions/loadingDatas').then(() => {
              next();
            }, () => {
              next({
                name: 'Dashboard'
              });
            });
          }
        }
        else if (Permissions.methods.$freeParticulier()){
          next();
        }
        else {
          next({
            name: 'Subscriptionchoice'
          });
        }
      },
      children: [{
        path: 'roles',
        name: 'PermissionsRoles',
        component: require('../views/permissions/Roles').default,
        beforeEnter: (to, from, next) => {
          if (store.getters['auth/permissions'].includes(Constants.PERMISSION_GESTION_DROITS_ROLE_LISTE)) {
            store.commit('app/SET_ALLOWED', true);
          } else {
            store.commit('app/SET_ALLOWED', false);
          }
          store.dispatch('roles/loadRoles').then(() => {
            next();
          }, () => {
            next({
              name: 'Dashboard'
            });
          });
        },
      },
      {
        path: 'referents',
        name: 'PermissionsReferents',
        component: require('../views/permissions/Referents').default,
        beforeEnter: (to, from, next) => {
          if (store.getters['auth/permissions'].includes(Constants.PERMISSION_GESTION_DROITS_REFERENT_LISTE)) {
            store.commit('app/SET_ALLOWED', true);
          } else {
            store.commit('app/SET_ALLOWED', false);
          }
          store.dispatch('referents/loadReferents').then(() => {
            store.dispatch('roles/loadRoles');
            next();
          }, (error) => {
            console.log(error);
            next({
              name: 'Dashboard'
            });
          });
        },
      },
      {
        path: 'beneficiariesReferent/:idReferent',
        name: 'PermissionsBeneficiariesReferent',
        component: require('../views/permissions/BeneficiariesReferent').default,
        beforeEnter: (to, from, next) => {
          store.commit('app/SET_LOADING', true);
          if (store.getters['auth/permissions'].includes(Constants.PERMISSION_GESTION_DROITS_REFERENT_DROITS_SUR_NEOPASS)) {
            store.commit('app/SET_ALLOWED', true);
          } else {
            store.commit('app/SET_ALLOWED', false);
          }
          store.dispatch('beneficiariesReferent/loadBeneficiariesReferent', to.params.idReferent).then(() => {
            store.dispatch('roles/loadRoles');
            store.commit('app/SET_LOADING', false);
            next();
          }).catch(() => {
            store.commit('app/SET_LOADING', false);
            next({name:'notAllowed'});
          });
        },
      },
      {
        path: 'beneficiaries',
        name: 'PermissionsBeneficiaries',
        component: require('../views/permissions/Beneficiaries').default,
        beforeEnter: (to, from, next) => {
          if (store.getters['auth/permissions'].includes(Constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_LISTE)) {
            store.commit('app/SET_ALLOWED', true);
          } else {
            store.commit('app/SET_ALLOWED', false);
          }
          store.dispatch('beneficiaries/loadBeneficiaries',             {
            hasLoading: true,
            hasPagination: 1,
          }).then(() => {
            store.dispatch('beneficiaries/loadTemplates');
            next();
          });
        },
      },
      {
        path: '/gestioninvite',
        name: 'PermissionsGuests',
        component: require('../views/permissions/Guests').default,
        beforeEnter: (to, from, next) => {
          store.commit('app/SET_ALLOWED', false);

          if (Permissions.methods.$freeParticulier()) {
            store.commit('app/SET_ALLOWED', true);
          }

          store.dispatch('invites/loadGuests').then(() => {
            next();
          });
        }
      },
      ]
    },
    {
      path: '/documents',
      name: 'Documents',
      component: require('./../views/depotDocuments/DepotDocuments').default,
      beforeEnter(to, from, next) {
        if (store.getters['auth/permissions'].includes(Constants.PERMISSION_DEPOT_DOCUMENTS_PAGE)) {
          store.commit('app/SET_ALLOWED', true);
        }
        else{
          store.commit('app/SET_ALLOWED', false);
        }
        store.commit('depotDocuments/SET_TARGETID', store.getters['auth/user'].id);
        store.dispatch('depotDocuments/loadFiles').then(() => {
          next();
        });
      },
    },
    {
      path: '/competences',
      name: 'Competences',
      component: require('./../views/competences/Competences').default,
    }
  ]
},
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

async function checkForUnsavedContent(from, to) {
  //Vérifie si les données ont été sauvegardées quand l'utilisateur quitte un formulaire
  let fromNeopass = /\/form\/neopass\/[0-9]*/.test(from);
  let fromTemplate = /\/modeles-de-page/.test(from);

  if (!fromTemplate && !fromNeopass) {
    return false;
  }

  if (fromNeopass) {
    return !await store.dispatch('neopass/checkContent', {url: to});

  }

  if (fromTemplate && from !== to) { //Le router est appelé quand le hash change, on évite de recharger la page en vérifiant si la route est toujours la même
    return !await store.dispatch('template/checkContent', {url: to});
  }else {
    return false;
  }
}

router.beforeEach(async (to, from, next) => {
  let unsavedContent = await checkForUnsavedContent(from.path, to.path);

  if (unsavedContent) {
    next(false);
  } else {
    store.commit('app/SET_LOADING', true);
    let redirection = await handleRedirects(to, from);
    await store.dispatch('listMenus/load_menus', to.path);
    redirection ? next(redirection) : next();
  }
});

async function handleRedirects(to, from) {
  const
    loggedIn = store.getters['auth/authenticated'],
    guest = Permissions.methods.$isGuest(),
    particulier = Permissions.methods.$freeParticulier(),
    destinationRequiresAuth = to.matched.some(record => record.meta.requireAuth),
    destinationIsHiddenFromAuth = to.matched.some(record => record.meta.hideForAuth),
    goingToGuestLogin = to.name === 'LoginGuest',
    goingToRefPasswordCreation = to.name === 'CreateReferentPassword',
    goingToNeopass = /\/form\/neopass\/[0-9]*/.test(to.path),
    goingToAnySubscription = ['Subscriptionchoice', 'Subscriptionstandard', 'Accountinformations'].includes(to.name),
    isFirstLofin = store.getters['auth/isFirstLogin'],
    subscribed = Permissions.methods.$subscribed(),
    superAdmin = store.getters['auth/role'] === Constants.ROLE_SUPER_ADMIN;

  let url;

  if(goingToRefPasswordCreation){
    await store.dispatch('auth/logout');
    return;
  }
  if(goingToGuestLogin){
    return;
  }
  if (destinationRequiresAuth && !loggedIn) {
    if(to.query.affiliate){
      store.commit('app/SET_AFFILIATECODE', to.query.affiliate);
    }
    return {name: 'Login'};
  }
  if (destinationIsHiddenFromAuth && loggedIn) {
    return from;
  }
  if (to.matched.length === 0) { //Page not found (404 error)
    return '/notFound';
  }
  if(guest && !goingToNeopass){
    return `/form/neopass/${store.getters['auth/user'].user_id}`;
  }

  if (loggedIn && !superAdmin && !particulier && !subscribed && isFirstLofin && !goingToAnySubscription) {
    return { name: 'Subscriptionchoice' };
  }
  

  //To do when go to a neopass form page
  if (goingToNeopass) {
    url = to.path.split('/form/neopass/')[1].split('/');
    const neopassId = url[0], moduleName = url[1], pageName = url[2];
    store.commit('app/SET_ALLOWED', true);

    try {
      await store.dispatch('neopass/first_load_page', url);
      let module;
      if(store.getters['neopass/listModulesPages'].length === 0){
        console.log('je ne suis pas autorisé');
        store.commit('app/SET_ALLOWED', false);
        return;
      }
      if (moduleName === undefined) { // default first page
        module = store.getters['neopass/listModulesPages'][0];
        return {
          path: `/form/neopass/${url[0]}/${module.name}/${module.pages[0].name}`
        };
      }
      if (pageName === undefined) {
        module = store.getters['neopass/listModulesPages'].filter(m => m.name === url[1])[0];
        return {
          path: `/form/neopass/${url[0]}/${module.name}/${module.pages[0].name}`
        };
      }

      await store.dispatch('neopass/change_page', url);

      //Module CV Pro is free. Others are premium or accessible for particulier user
      if (moduleName === Constants.MODULE_NEOPASS_FORM_CV_PROFESSIONNEL) {
        if(!(store.getters['auth/permissionsOnBeneficiariesNeopass'][neopassId].includes(pageName+'_read')
                    || store.getters['auth/permissionsOnBeneficiariesNeopass'][neopassId].includes(pageName+'_edit'))
        ){
          store.commit('app/SET_ALLOWED', false);
        }

        return;
      }
      if(moduleName === Constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES || moduleName === Constants.MODULE_NEOPASS_FORM_COMPETENCES_SCOLAIRES){
        await store.dispatch('neopass/getJob');
        await store.dispatch('neopass/loadJobs');
      }

      return;

    }catch (e) {
      return {name: 'Neopass'};
    }

  }

  let toTemplate = /\/modeles-de-page/.test(to.path);
  if (toTemplate) {
    await store.commit('app/SET_ALLOWED', true);
        
    if (!store.getters['auth/permissions'].includes(Constants.PERMISSION_MODELE_DE_PAGE_PAGE)) {
      store.commit('app/SET_ALLOWED', false);
    }

    url = to.path.split('/modeles-de-page/')[1].split('/');

    try {
      await store.dispatch('template/first_load_page', url);
      await store.dispatch('template/change_page', url);
    }catch (e) {
      return {name: 'Dashboard'};
    }
  }
}

// Scroll to top of main block after entering new route
//const scrollableElementSelector = 'main'
router.afterEach(() => {
  let pos = document.getElementById('main-router-view');
  if(pos){
    setTimeout(() => {pos.scrollIntoView({behavior: 'smooth', block:'start'});}, 200);
  }
});

export default router;
